import { getAmpConfig } from 'shared/config/amp-config';
import { RelevantDomains } from 'shared/lib/domains';

export const getAssignmentServiceUrl = () =>
  `${getAmpConfig().gateway}/assignment-service`;

export enum AssignmentsQueryTagTypes {
  ASSIGNMENT = 'Assignment',
}

export const SSC_QUERY_PARAM = 'includeSingleSessionCodesForUser';

export const CKLA_PILOT_DOMAIN: RelevantDomains = 'CKLA Pilot';
export const CKLA_DOMAIN: RelevantDomains = 'CKLA';

export const CKLA_PILOT_SUBROUTE_URL =
  'collection/670842eb95c229d664c3f010?checkAmplifyLogin=true';
